import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import AxoniusConfigListing from "./AxoniusConfigListing";
import AxoniusCredentialsForm from "./AxoniusCredentialsForm";

const AxoniusPullAndPushView = (props) => (
  <GenericPullAndPushToolView
    {...props}
    PullCredentialForm={AxoniusCredentialsForm}
    PullConfigListingView={AxoniusConfigListing}
  />
);

export default AxoniusPullAndPushView;
